// the file containing the components for the customer profile screen
import React, { FunctionComponent, useEffect, useState } from 'react'
import { types } from '@homevest/timelines/'
import { Helmet } from 'react-helmet'

import { TwoColumn } from 'components/TailwindUIToolkit'
import Timeline from './Timeline'
import PersonalDetails from './PersonalDetails'
import ApplicationFees from './ApplicationFees'
import Tours from './Tours'
import PrequalificationDetails from './PrequalificationDetails'
import LeadGroup from './LeadGroup'
import Properties from './Properties'
import Applications from './Applications'
import Rentals from './Rentals'
// import BreadcrumbBar from './BreadcrumbBar'
import PageTitle from './PageTitle'
import Note from './Note'
import Documents from './Documents'
import CloseActivity from './CloseActivity'
import axios from 'lib/axios'
import { Customer } from './types'
import Modals from './Modals'
import { DynamicWidthPageContainer } from 'components/TailwindUIToolkit/Layouts/DynamicWidthPageContainer'

import IdentityVerification from './IdentityVerificationDetails'

const CustomerProfile: FunctionComponent<React.PropsWithChildren<{ userId: string }>> = ({
  userId
}) => {
  const [response, setResponse] = useState<types.TimelineResponse>()
  const [loading, setLoading] = useState(false)
  const [userName, setUserName] = useState({
    firstName: '...',
    lastName: '...',
    displayName: '...'
  })
  useEffect(() => {
    setLoading(true)
    axios
      .get(`/360/users/${userId}/timeline`)
      .then((response) => {
        setLoading(false)
        setResponse(response.data)
      })
      .catch((err) => {
        throw err
      })
  }, [userId])

  const customer: Customer = {
    userId,
    firstName: userName.firstName,
    lastName: userName.lastName,
    displayName: userName.displayName
  }

  const mainContent = (
    <>
      <PersonalDetails userId={userId} setProfileName={setUserName} />
      <ApplicationFees userId={userId} />
      <Timeline customer={customer} timelineResponse={response} loading={loading} />
      <CloseActivity userId={userId} />
      <Documents userId={userId} />
      <Note userId={userId} />
    </>
  )

  const sidebarContent = (
    <>
      <Tours userId={userId} />
      <PrequalificationDetails userId={userId} />
      <IdentityVerification userId={userId} />
      <Applications userId={userId} />
      <Rentals userId={userId} />
      <Properties homes={response?.properties} />
      <LeadGroup userId={userId} />
    </>
  )

  // TODO: implement working breadcrumb history

  return (
    <>
      <Helmet>
        <title>{customer.displayName}</title>
      </Helmet>
      <DynamicWidthPageContainer
        breadcrumbBar={true}
        pathToPage={[
          { name: 'Users', href: '/users/' },
          { name: customer.displayName, href: '#' }
        ]}
      >
        <div className='mb-4 h-fit'>
          {/* <BreadcrumbBar history={breadcrumbPages} /> */}
          <PageTitle customer={customer} />
        </div>
        <TwoColumn mainContent={mainContent} sidebarContent={sidebarContent} sidebarSide='right' />
        <Modals />
      </DynamicWidthPageContainer>
    </>
  )
}

export default CustomerProfile
